"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var _regeneratorRuntime = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DefaultBrowserBehavior_1 = require("../browserbehavior/DefaultBrowserBehavior");

var DefaultDeviceController_1 = require("../devicecontroller/DefaultDeviceController");

var ContentShareMediaStreamBroker = /*#__PURE__*/function () {
  function ContentShareMediaStreamBroker(logger) {
    _classCallCheck(this, ContentShareMediaStreamBroker);

    this.logger = logger;
  }

  _createClass(ContentShareMediaStreamBroker, [{
    key: "acquireAudioInputStream",
    value: function acquireAudioInputStream() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this._mediaStream.getAudioTracks().length === 0)) {
                  _context.next = 3;
                  break;
                }

                this.logger.info('No audio stream available. Synthesizing an audio stream.');
                return _context.abrupt("return", DefaultDeviceController_1.default.synthesizeAudioDevice(0));

              case 3:
                return _context.abrupt("return", this._mediaStream);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "acquireVideoInputStream",
    value: function acquireVideoInputStream() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", this._mediaStream);

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "releaseMediaStream",
    value: function releaseMediaStream(_mediaStreamToRelease) {
      this.logger.warn('release media stream called');
      return;
    }
  }, {
    key: "acquireDisplayInputStream",
    value: function acquireDisplayInputStream(streamConstraints) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(streamConstraints && streamConstraints.video && // @ts-ignore
                streamConstraints.video.mandatory && // @ts-ignore
                streamConstraints.video.mandatory.chromeMediaSource && // @ts-ignore
                streamConstraints.video.mandatory.chromeMediaSourceId)) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return", navigator.mediaDevices.getUserMedia(streamConstraints));

              case 2:
                return _context3.abrupt("return", navigator.mediaDevices.getDisplayMedia(streamConstraints));

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
    }
  }, {
    key: "bindToAudioVideoController",
    value: function bindToAudioVideoController(_audioVideoController) {
      throw new Error('unsupported');
    }
  }, {
    key: "acquireScreenCaptureDisplayInputStream",
    value: function acquireScreenCaptureDisplayInputStream(sourceId, frameRate) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", this.acquireDisplayInputStream(this.screenCaptureDisplayMediaConstraints(sourceId, frameRate)));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "screenCaptureDisplayMediaConstraints",
    value: function screenCaptureDisplayMediaConstraints(sourceId, frameRate) {
      return {
        audio: !sourceId && new DefaultBrowserBehavior_1.default().getDisplayMediaAudioCaptureSupport() ? true : false,
        video: Object.assign(Object.assign({}, !sourceId && {
          frameRate: {
            max: frameRate ? frameRate : ContentShareMediaStreamBroker.defaultFrameRate
          }
        }), sourceId && {
          mandatory: {
            chromeMediaSource: 'desktop',
            chromeMediaSourceId: sourceId,
            maxFrameRate: frameRate ? frameRate : ContentShareMediaStreamBroker.defaultFrameRate
          }
        })
      };
    }
  }, {
    key: "toggleMediaStream",
    value: function toggleMediaStream(enable) {
      var changed = false;

      if (this.mediaStream) {
        for (var i = 0; i < this.mediaStream.getTracks().length; i++) {
          if (this.mediaStream.getTracks()[i].enabled !== enable) {
            this.mediaStream.getTracks()[i].enabled = enable;
            changed = true;
          }
        }
      }

      return changed;
    }
  }, {
    key: "cleanup",
    value: function cleanup() {
      if (this.mediaStream) {
        for (var i = 0; i < this.mediaStream.getTracks().length; i++) {
          var track = this.mediaStream.getTracks()[i];
          track.stop();
        }
      }

      this.mediaStream = null;
    }
  }, {
    key: "mediaStream",
    get: function get() {
      return this._mediaStream;
    },
    set: function set(mediaStream) {
      this._mediaStream = mediaStream;
    }
  }]);

  return ContentShareMediaStreamBroker;
}();

exports.default = ContentShareMediaStreamBroker;
ContentShareMediaStreamBroker.defaultFrameRate = 15;